export const CATEGORY_ARTICLES_PER_PAGE = 6;
export const PRESS_ARTICLES_PER_PAGE = 6;
export const ARTICLES_PER_PAGE = 9;
export const PRESS_SLUG = 'ueber-uns/presse';
export const PRESS_SLUG_SLASH = `${PRESS_SLUG}/`;
